"use strict";

// todo сюда поместить весь код, ответственный за переключение одностраничного режима

$(document).on(Fotobook.events.BOOKBIND_CHANGED, function(event, bookbind){
    if (bookbind && bookbind.spread_content && Fotobook.book.single_page_mode) {
        Fotobook.changeSinglePageMode(false);
        //При переходе в многостраничный режим убираем галочку в чек-боксе одностраничного режима
        $("#single-page-switch").prop('checked', false);
    }
});